import React, { useState, useRef, useEffect, useContext } from 'react';
import EmojiPicker from 'emoji-picker-react';
import { AuthContext } from "../../util/api";

import api from '../../util/api';
import { showAlert } from '../../util/api';
import { Link } from "react-router-dom";

const AdminChatLauncher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [showEmoji, setShowEmoji] = useState(false);
  const { token, User, checkkyc } = useContext(AuthContext);
  const messagesEndRef = useRef(null);
  let startsoundcount = 0;

  // Function to play chat sound
  const playChatSound = () => {
    const audio = document.getElementById('chat-audio');
    if (audio) {
      audio.currentTime = 0;
      audio.play();
    }
  };


  const stopChatSound = () => {
    const audio = document.getElementById('chat-audio');
    if (audio) {

      audio.pause();
      audio.currentTime = 0;
    }
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);


    setCountMessage(0);
    stopChatSound();


  }
  const toggleExpand = () => setIsExpanded(!isExpanded);

  //imported scripts  

  const perPage = 10;
  const chatBoxRef = useRef(null);
  const [page, setPage] = useState(1);
  const [messagesHtml, setMessagesHtml] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const receiverId = User != null && User['id'] ? User['id'] : 0;
  const [count_message, setCountMessage] = useState(0);

  // Use a ref to always get the latest isOpen value
  const isOpenRef = useRef(isOpen);
  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  const fetchMessages = async (receiverId, page = 1, append = true, scroll = false) => {
    if (isLoading) return;

    setIsLoading(true);

    const lastMessageId = chatBoxRef.current?.dataset?.lastMessageId || 0;

    const url = scroll
      ? `/chat/messages?page=${page}&perPage=${perPage}&receiver_id=${receiverId}&last_id=${lastMessageId}&scroll=true`
      : `/chat/messages?page=${page}&perPage=${perPage}&receiver_id=${receiverId}&last_id=${lastMessageId}`;

    try {
      const response = await api.get(url);
      const newHtml = response.data.html;

      if (response.data.status == 'successful') {
        if (newHtml) {
          setMessagesHtml(prev => (append ? prev + newHtml : newHtml + prev));

          if (!isOpenRef.current) {

            setCountMessage(prev => prev + 1);
            playChatSound();

          }
          if (append && chatBoxRef.current) {
            chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
          }
        }
      } else {
        showAlert('error', 'error', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Scroll event to load old messages
  const handleScroll = () => {
    if (!chatBoxRef.current) return;

    const scrollTop = chatBoxRef.current.scrollTop;
    const scrollHeight = chatBoxRef.current.scrollHeight;

    if (scrollTop === 0) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchMessages(receiverId, nextPage, false, true).then(() => {
        chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight - scrollHeight + 2;
      });
    }
  };

  // Polling
  useEffect(() => {
    if (User != null) {
      const interval = setInterval(() => {
        if (receiverId) fetchMessages(receiverId);
      }, 30000);

      return () => clearInterval(interval);
    }

  }, [receiverId]);

  // Attach scroll event once
  useEffect(() => {
    const chatEl = chatBoxRef.current;
    if (chatEl) {
      chatEl.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (chatEl) chatEl.removeEventListener('scroll', handleScroll);
    };
  }, [page]);




  //end imported scripts  



  const handleEmojiClick = (emojiData) => {
    setInput(prev => prev + emojiData.emoji);
    setShowEmoji(false);
  };


  const handleSend = async () => {

    if (!input.trim() && !attachment) return;
    let formData = null;


    formData = new FormData();
    if (attachment) {
      formData.append('file', attachment);
    }
    formData.append('sender', User['name']);
    formData.append('text', input);
    formData.append('message', input);
    formData.append('sender_id', User['id']);
    formData.append('user_id', User['id']);
    formData.append('receiver_id', 0);


    const response = await api.post(
      `/send_chat`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    const newMessage = {
      sender: User['name'],
      text: input,
      message: input,
      sender_id: User['id'],
      user_id: User['id'],
      receiver_id: 0
    };
    //send the  details to the server .. 
    setMessages(prev => [...prev, newMessage]);

    const outcome = response.data;
    if (outcome.status == "successful") {

      const newHtml = response.data.html;

      if (newHtml) {

        let append = true;
        setMessagesHtml(prev => (append ? prev + newHtml : newHtml + prev));
        if (append && chatBoxRef.current) {
          chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
        }
      }


      setInput('');
      setAttachment(null);

    } else {

      showAlert('error', 'error', outcome.message);
    }

    //send the  details to the server ...  

  };



  const getChat = async () => {
    const newMessage = {

      user_id: User['id'],

    };
    //send the  details to the server .. 
    const response = await api.post(
      `/get_chat`,
      newMessage
    );
    const outcome = response.data;
    if (outcome.status == "successful") {
      const newHtml = response.data.html;
      setCountMessage(response.data.message_count);
      if (newHtml) {
        let append = true;
        setMessagesHtml(prev => (append ? prev + newHtml : newHtml + prev));
        if (append && chatBoxRef.current) {
          chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
        }
      }

    } else {

      showAlert('error', 'error', outcome.message);
    }

    //send the  details to the server ...  

  };

  const didRun = useRef(false);

  useEffect(() => {
    if (User != null) {
      if (!didRun.current) {
        getChat();
        didRun.current = true;
      }
    }
  }, []);



  useEffect(() => {
    if (User != null) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);



  return (
    <>
      <audio id="chat-audio" src="live_chat.mp3" />
      <div
        style={{
          position: 'absolute',
          bottom: 66,
          left: 10,
          width: 100,
          height: 60,
          borderRadius: '50%',
          fontSize: 24,
          cursor: 'pointer',
          zIndex: 1000
        }}


      >
        {<div style={{ position: "relative", top: "1cm" }}>

          {count_message !== 0 ?

            <strong
              style={{
                color: "red",
                backgroundColor: "white",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px",
                fontWeight: "bold"
              }}
            >
              {count_message}
            </strong>
            : <>    &nbsp; </>}


        </div>

        }
        <img onClick={toggleChat} src="/chat_with.png" alt="Chat attention grabber"
          style={{ width: '100px', height: '110px', objectFit: 'cover' }}></img>

      </div>
      {/*   <button
        onClick={toggleChat}
        style={{
          position: 'fixed',
          bottom: 20,
          right: 25,
          width: 60,
          height: 60,
          borderRadius: '50%',
          fontSize: 24,
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          boxShadow: '0 8px 16px rgba(0,0,0,0.25)',
          cursor: 'pointer',
          zIndex: 1000
        }}
        title="Chat with us"
      >

        {count_message != 0 && <strong style={{ color: "red" }}> {count_message}</strong>}
        💬
      </button> */}

      {(isOpen && token != null) && (
        <div
          style={{
            position: 'fixed',
            bottom: 90,
            left: 20,
            width: '95%',
            maxWidth: 400,
            height: isExpanded ? '80vh' : '500px',
            borderRadius: 16,
            backgroundColor: '#fff',
            boxShadow: '0 12px 32px rgba(0,0,0,0.2)',
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >


          <div style={{
            background: 'linear-gradient(90deg, #007bff, #00c6ff)',
            color: '#fff',
            padding: '12px 14px',
            fontWeight: '600',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>

            <button onClick={toggleExpand} style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: '#fff',
              padding: '4px 10px',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 12
            }}>
              {isExpanded ? 'Collapse' : 'Expand'}
            </button>

            <button onClick={toggleChat} className='btn btn-sm btn-danger'> Close </button>
          </div>

          <div style={{ background: 'linear-gradient(90deg, #007bff, #00c6ff)' }}>
            <span style={{ color: "white", paddingLeft: "5px", fontWeight: "bolder" }}>Submit your request to Support, and we’ll respond promptly.</span>

          </div>

          <div
            id={`chat-box-${receiverId}`}
            className="chat-box-content"
            ref={chatBoxRef}
            data-receiver-id={receiverId}
            data-last-message-id="0"
            data-page={page}
            dangerouslySetInnerHTML={{ __html: messagesHtml }}
            style={{
              padding: 12,
              flex: 1,
              overflowY: 'auto',
              backgroundColor: '#f4f6f8',
              borderTop: '1px solid #eee',
              borderBottom: '1px solid #eee'
            }} />

          <div style={{ padding: 12 }}>
            <div style={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: 8
            }}>
              <button
                onClick={() => setShowEmoji(prev => !prev)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: 22,
                  cursor: 'pointer'
                }}
                title="Emoji"
              >😊</button>

              <textarea
                value={input}
                onChange={e => setInput(e.target.value)}
                rows={2}
                placeholder="Type your message..."
                style={{
                  flex: 1,
                  resize: 'none',
                  padding: 8,
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  fontSize: 14,
                  fontFamily: 'inherit'
                }}
              />

              <label style={{ fontSize: 20, cursor: 'pointer' }} title="Attach file">
                📎
                <input
                  type="file"
                  onChange={e => setAttachment(e.target.files[0])}
                  style={{ display: 'none' }}
                />
              </label>

              <button
                onClick={handleSend}
                style={{
                  backgroundColor: '#007bff',
                  color: '#fff',
                  padding: '8px 12px',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 14
                }}
              >
                Send
              </button>
            </div>

            {/* Preview selected attachment */}
            {attachment && (
              <div style={{ marginTop: 8 }}>
                {attachment.type.startsWith('image/') ? (
                  <img
                    src={URL.createObjectURL(attachment)}
                    alt="attachment preview"
                    style={{ maxWidth: 120, maxHeight: 120, borderRadius: 8, border: '1px solid #ccc' }}
                  />
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span role="img" aria-label="file">📄</span>
                    <span>{attachment.name}</span>
                  </div>
                )}
              </div>
            )}

            {showEmoji && (
              <div style={{ position: 'absolute', bottom: isExpanded ? '28vh' : 260, right: 20, zIndex: 1000 }}>
                <EmojiPicker onEmojiClick={handleEmojiClick} />
              </div>
            )}
          </div>
        </div>
      )}

      {(isOpen && token == null) && (
        <div
          style={{
            position: 'fixed',
            bottom: 90,
            right: 20,
            width: '95%',
            maxWidth: 400,
            height: isExpanded ? '80vh' : '500px',
            borderRadius: 16,
            backgroundColor: '#fff',
            boxShadow: '0 12px 32px rgba(0,0,0,0.2)',
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          <div style={{
            padding: 24,
            textAlign: 'center',
            color: '#333',
            fontSize: 16
          }}>
            Please log in or register to access the chat feature. Thank you.
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 16,
            marginBottom: 24,
            marginTop: 8
          }}>
            <Link
              to="/register"
              style={{
                padding: '10px 28px',
                background: 'linear-gradient(90deg, #00c6ff, #007bff)',
                color: '#fff',
                borderRadius: 8,
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 2px 8px rgba(0,123,255,0.15)',
                transition: 'background 0.2s, box-shadow 0.2s',
                border: 'none',
                fontSize: 16,
                letterSpacing: 1,
                outline: 'none'
              }}
              onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #007bff, #00c6ff)'}
              onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #00c6ff, #007bff)'}
              onClick={toggleChat}
            >
              Register
            </Link>
            <Link
              onClick={toggleChat}
              to="/login"
              style={{
                padding: '10px 28px',
                background: 'linear-gradient(90deg, #ff512f, #dd2476)',
                color: '#fff',
                borderRadius: 8,
                fontWeight: 600,
                textDecoration: 'none',
                boxShadow: '0 2px 8px rgba(221,36,118,0.15)',
                transition: 'background 0.2s, box-shadow 0.2s',
                border: 'none',
                fontSize: 16,
                letterSpacing: 1,
                outline: 'none'
              }}
              onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #dd2476, #ff512f)'}
              onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #ff512f, #dd2476)'}

            >
              Login
            </Link>
          </div>
        </div>
      )}

    </>
  );
};

export default AdminChatLauncher;
